import { createAction, handleActions } from "redux-actions";

const actionScope = "CREATOR_SESSION_";

export const creatorSessionRequestFail = createAction(actionScope + "CREATOR_SESSION_REQUEST_FAIL");

//#region Actions
export const loadOrganizationsRequest = createAction(actionScope + "LOAD_ORGANIZATION_REQUEST");
export const loadOrganizationsSuccess = createAction(actionScope + "LOAD_ORGANIZATION_SUCCESS");

export const updateOrganizationRequest = createAction(actionScope + "UPDATE_ORGANIZATION_REQUEST");
export const updateOrganizationSuccess = createAction(actionScope + "UPDATE_ORGANIZATION_SUCCESS");

export const deleteOrganizationRequest = createAction(actionScope + "DELETE_ORGANIZATION_REQUEST");
export const deleteOrganizationSuccess = createAction(actionScope + "DELETE_ORGANIZATION_SUCCESS");

export const setSelectedOrganizationRequest = createAction(
  actionScope + "SET_SELECTED_ORGANIZATION_ODM_REQUEST"
);
export const setSelectedOrganizationSuccess = createAction(
  actionScope + "SET_SELECTED_ORGANIZATION_ODM_SUCCESS"
);
//#endregion

//selectors
export const organizationODMsSelector = state => state.creatorSession.organizationODMs;

// initial state
const initialState = {
  selectedOrganizationODM: null,
  organizationODMs: null, //this doesn't always need to be loaded,
};

// reducers
export default handleActions(
  {
    [creatorSessionRequestFail]: state => state,

    [loadOrganizationsRequest]: state => state,
    [loadOrganizationsSuccess]: (state, { payload }) => ({
      ...state,
      organizationODMs: payload,
    }),

    [updateOrganizationRequest]: state => state,
    [updateOrganizationSuccess]: (state, { payload }) => ({
      ...state,
      organizationODMs: payload,
    }),

    [deleteOrganizationRequest]: state => state,
    [deleteOrganizationSuccess]: (state, { payload }) => ({
      ...state,
      organizationODMs: payload,
    }),

    [setSelectedOrganizationRequest]: state => state,
    [setSelectedOrganizationSuccess]: (state, { payload }) => ({
      ...state,
      selectedOrganizationODM: payload,
    }),
  },
  initialState
);
